import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import uniqid from 'uniqid'

import './RadioButton.scss'

export const RADIOBUTTON_LABEL_DEFAULT = 'default'
export const RADIOBUTTON_LABEL_FW_STANDARD = 'fw-standard'

export const RadioButton = ({
  checked,
  className,
  disabled,
  id,
  label,
  labelClassName,
  labelVariant,
  name,
  onChange,
  value,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataAttributeTip
}) => {
  const containerClass = classnames(className, 'c-radio-button', {
    'c-radio-button--disabled': disabled
  })

  const inputName = name ? `input-${name}` : uniqid('input-')
  const inputId = id || `${inputName}-${value}`

  return (
    <span className={containerClass} data-tip={dataAttributeTip}>
      <label
        htmlFor={inputId}
        data-mu-test={classnames('radio-button', dataAttributeTest)}
      >
        <input
          type='radio'
          className={'c-radio-button__input'}
          name={name}
          id={inputId}
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span
          className={classnames(
            'c-radio-button__label',
            {
              'c-radio-button__label--fw-standard':
                labelVariant === RADIOBUTTON_LABEL_FW_STANDARD
            },
            labelClassName
          )}
        >
          {label}
        </span>
      </label>
    </span>
  )
}

RadioButton.defaultProps = {
  labelVariant: RADIOBUTTON_LABEL_DEFAULT
}

RadioButton.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelClassName: PropTypes.string,
  labelVariant: PropTypes.oneOf([
    RADIOBUTTON_LABEL_DEFAULT,
    RADIOBUTTON_LABEL_FW_STANDARD
  ]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
